import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Sidebar from '../Sidebar/Sidebar';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="admin-layout" style={{ background: '#101113', height: '100vh', display: 'flex', overflow: 'hidden' }}>
      <Sidebar />
      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#101113' }}>
        <div style={{ 
          maxWidth: '500px', 
          width: '90%', 
          padding: '3rem', 
          background: 'rgba(255, 255, 255, 0.02)', 
          borderRadius: '32px', 
          border: '1px solid rgba(255, 255, 255, 0.05)', 
          textAlign: 'center',
          backdropFilter: 'blur(20px)',
          boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
        }}>
          <div style={{ 
            width: '80px', 
            height: '80px', 
            background: 'rgba(255, 65, 53, 0.1)', 
            color: '#ff4135', 
            borderRadius: '24px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            fontSize: '2.5rem', 
            margin: '0 auto 2rem' 
          }}>
            <FontAwesomeIcon icon={faCircleXmark} />
          </div>
          <h1 style={{ color: 'white', fontSize: '2rem', fontWeight: '800', marginBottom: '1rem' }}>Payment Cancelled</h1>
          <p style={{ color: 'rgba(255,255,255,0.4)', lineHeight: '1.6', marginBottom: '2.5rem' }}>
            The subscription renewal process was cancelled. No charges were made to your account.
          </p>
          <button 
            onClick={() => navigate('/admin/settings')}
            style={{ 
              width: '100%', 
              padding: '1.2rem', 
              background: 'rgba(255,255,255,0.05)', 
              color: 'white', 
              border: 'none', 
              borderRadius: '16px', 
              fontWeight: '800', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.8rem'
            }}
          >
            <FontAwesomeIcon icon={faArrowLeft} /> Return to Settings
          </button>
        </div>
      </main>
    </div>
  );
};

export default SubscriptionCancel;
